// contexts/AuthContext.tsx
import React, { createContext, useContext, useState, useEffect } from 'react'; 
import { KullaniciModal } from '../types/modals';

interface AuthContextType {
  kullaniciModal: KullaniciModal | null;
  setKullaniciModal: (kullanici: KullaniciModal | null) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [kullaniciModal, setKullaniciModalState] = useState<KullaniciModal | null>(() => {
    // localStorage'dan kullanıcı bilgilerini al
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // kullaniciModal değiştiğinde localStorage'ı güncelle
  useEffect(() => {
    if (kullaniciModal) {
      localStorage.setItem('user', JSON.stringify(kullaniciModal));
    } else {
      localStorage.removeItem('user');
    }
  }, [kullaniciModal]);

  const setKullaniciModal = (kullanici: KullaniciModal | null) => {
    setKullaniciModalState(kullanici);
  };

  const logout = () => {
    setKullaniciModalState(null);
    localStorage.removeItem('user');
    // İsterseniz diğer cleanup işlemlerini de burada yapabilirsiniz
  };

  return (
    <AuthContext.Provider value={{ kullaniciModal, setKullaniciModal, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};